export default __webpack_public_path__ + "static/media/Geyser-Brochure-2024.d0117327.pdf";